import React, { Fragment, useMemo } from "react";
import { PlatformsAndSocials } from "./PlatformsAndSocials";
import { ProfileSetupButtons } from "../ProfileSetupButtons";
import { BASIC_INFO_KEY, BIO_KEY, LINKS_KEY } from "../../../../enums/profileSetupEnums";
import { arraySorter } from "../../../../helpers/arrayHelper";
import { useCategories } from "../../../../hooks/apiHooks/useCategories";
import DialogLayout from "../../../layouts/DialogLayout";
import { useFormik } from "formik";
import { createOrUpdateCategoriesValues } from "../../../../config/apisauce";
import useNotiStack from "../../../../hooks/useNotiStack";
import { formatCategoryValues } from "../../../../components/generic/functions/genericFunctions";

export const LinksForm = ({ handleChangeForm, initialUserDetail, fetchUserDetails }) => {
  const { error } = useNotiStack();
  // const [followerCount, setFollowerCount] = useState({});
  const { data: categories } = useCategories({ type: ['socials', 'platforms'] });
  const userId = initialUserDetail?.user?.id;
  const linksValues = initialUserDetail?.user?.category_values;

  const linksInitialValues = useMemo(() => {
    return formatCategoryValues(linksValues);
  }, [linksValues]);

  // const handleChangeFollowerCount = (key, value) => {
  //   setFollowerCount((prev) => ({ ...prev, [key]: value }));
  // };

  const handleSubmit = async (data) => {
    // const excludedCategories = platformsAnSocials?.socials?.filter((item) => !item?.meta?.showFollowerCount)?.map((item) => item?.id);
    const validate = (array) => Object.entries(data).filter(([key, value]) => array.some((item) => item?.id === Number(key)) && value).length;
    // const linksWithValues = Object.keys(data).filter(key => !!data[key] && !excludedCategories.includes(Number(key)));
    // const countWithoutValues = Object.entries(followerCount).find(([key, value]) => (value === "" && linksWithValues?.includes(key)))?.[0] ?? null;

    if (validate(platformsAnSocials?.platforms) < 1) {
      error('Please add at least one platform.');
    } else if (validate(platformsAnSocials?.socials) < 1) {
      error('Please add at least one social media account.');
    }
    // else if (countWithoutValues) {
    //   error('Follower count is required!');
    // }
    else {
      const categories = Object.entries(data).map(([key, value]) => {
        // const categoryDetails = linksValues.find((item) => item?.categories_id === Number(key));
        return (
          {
            user_id: userId,
            categories_id: Number(key),
            value: value,
            // ...(categoryDetails?.category?.type === SOCIALS_KEY && {
            //   meta: {
            //     ...categoryDetails.meta ?? {},
            //     followerCount: parseInt(followerCount?.[Number(key)]) ?? null
            //   }
            // })
          }
        );
      });
      const response = await createOrUpdateCategoriesValues({
        current_step: BIO_KEY,
        categories: categories,
        user_id: userId,
      });
      if (response.ok) {
        handleChangeForm(BIO_KEY);
        fetchUserDetails();
      }
    }
  };

  const formik = useFormik({
    initialValues: linksInitialValues,
    enableReinitialize: true,
    onSubmit: (values) => handleSubmit(values)
  });

  const platformsAnSocials = useMemo(() => {
    const filterCategories = (type) => categories?.filter((item) => item?.type === type)?.map((item) => {
      return ({ ...item, order: item?.meta !== null ? item?.meta?.order : 7 });
    });
    const platforms = arraySorter(filterCategories('platforms'));
    const socials = arraySorter(filterCategories('socials'));
    return {
      platforms: platforms,
      socials: socials
    };
  }, [categories]);

  // useEffect(() => {
  //   const count = linksValues?.filter?.((item) => item?.category?.type === SOCIALS_KEY).reduce((acc, { categories_id, meta }) => {
  //     acc[categories_id] = meta?.followerCount ?? "";
  //     return acc;
  //   }, {});
  //   setFollowerCount(count);
  // }, [linksValues]);

  return (
    <Fragment>
      <DialogLayout>
        <PlatformsAndSocials
          fields={platformsAnSocials?.platforms}
          title={'Platforms'}
          subTitle={'one (1) platform'}
          formik={formik}
        />
        <PlatformsAndSocials
          fields={platformsAnSocials?.socials}
          title={'Socials'}
          subTitle={'one (1) social media account'}
          mt={5}
          formik={formik}
        // followerCount={followerCount}
        // handleChangeFollowerCount={handleChangeFollowerCount}
        />
      </DialogLayout>
      <ProfileSetupButtons handleBack={() => handleChangeForm(BASIC_INFO_KEY)} currentForm={LINKS_KEY} handleSubmit={() => formik.handleSubmit()} />
    </Fragment>
  );
};